// src/components/Chat/ChatRoomList.jsx

import {
    Box, Typography, Button,
    CircularProgress, Paper, Chip,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import { useCategory } from '../../contexts/CategoryContext'; // ✅ 전역 context

const ChatRoomList = () => {
    const navigate = useNavigate();
    const { chatCategories } = useCategory(); // ✅ context에서 가져오기

    const goToCategory = (id) => {
        navigate(`/main/chat/category/${id}`);
    };

    if (!chatCategories) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom>
                채팅방 목록
            </Typography>

            {chatCategories.length === 0 ? (
                <Typography>등록된 채팅방이 없습니다.</Typography>
            ) : (
                <Grid container spacing={2}>
                    {chatCategories.map((cat) => (
                        <Grid xs={12} sm={6} md={4} key={cat.id}>
                            <Paper
                                sx={{
                                    p: 2,
                                    width: 215,
                                    height: 180,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Box>
                                    <Typography variant="h6">
                                        {cat.emoji} {cat.name}
                                    </Typography>

                                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                        {cat.anonymous_option !== 'none' && (
                                            <Chip label="익명 가능" size="small" />
                                        )}
                                        {cat.is_private_only && (
                                            <Chip label="🔒 비공개 전용" color="warning" size="small" />
                                        )}
                                    </Box>
                                </Box>

                                <Box sx={{ textAlign: 'right', mt: 2 }}>
                                    <Button variant="outlined" onClick={() => goToCategory(cat.id)}>
                                        입장
                                    </Button>
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default ChatRoomList;